import {XCircleIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {selectFailedRequiredChecks} from './use-failed-checks-data'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'

// Surfaces a single summary item when the pull request has failing required checks.
// The parent ForYouItemBoundary decides which subsection (and thus which viewer) sees
// it via its `audience` prop, so this component stays audience-agnostic.
export function FailingChecks({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()
  const failedChecks = data && !data.isClosedOrMerged && selectFailedRequiredChecks(data.statusChecks)

  if (!failedChecks || failedChecks.length === 0) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={XCircleIcon} variant="danger" emphasized />}
      emphasizedLeadingVisual
      title="Required checks failing"
      itemName="failing-checks"
      description="Fix the failing required checks."
      variant={variant}
      actionSlot={<OverviewMergeControl data={data} itemName="failing-checks" />}
    />
  )
}
